import { compose } from 'redux';
import { connect } from 'react-redux';
import withAuth from '../../common/WithAuth';
import ListSeminarPreview from '../../pages/SeminarManagementOrganizer/ListSeminarPreview';

const mapStateToProps = () => ({});

const mapDispatchToProps = () => ({});

export default compose(
    withAuth,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(ListSeminarPreview);
